import { clsx } from 'clsx'
import { Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import React, { useId } from 'react'
import { inputClasses, labelClasses } from 'components/ui/inputClasses'

type BaseInput = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export type InputProps = Omit<BaseInput, 'value'> & {
  value: string
  setValue: (value: string) => void
  label: string
  error?: string
}

export const Input = ({ value, setValue, label, error, className, ...rest }: InputProps) => {
  const { t } = useTranslation()
  const id = useId()
  const errorId = `${id}-error`
  return (
    <div className={clsx('tw-flex tw-flex-col', className)}>
      <label htmlFor={id} className={labelClasses}>
        {label}
      </label>
      <input
        id={id}
        placeholder={label}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={inputClasses(!!error, 'tw-h-11')}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        {...rest}
      />
      <Transition
        show={!!error}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
        className={'tw-mt-1 tw-text-xs tw-text-red-600'}
      >
        <span id={errorId} role="alert">
          {error ? t(error) : null}
        </span>
      </Transition>
    </div>
  )
}
